import { FC, useCallback } from 'react';
import { buildCommissionSheetRow } from '../../utils/commissionSheet';
import DhSheetBulkExport, {
  IDhSheetPlacement,
  IDhSheetRow,
  sheetPlacement,
  sheetSplitting,
} from './DhSheetBulkExport';

// kan-98: kan-88 exports one placement's sheet row from the detail page. The
// executive works the dashboard a page at a time, so this exports every
// direct-hire placement on the page as those same A–U rows, in page order.

interface ICommissionSheetBulkExportProps {
  /** The rows currently loaded in the listing (whatever filters/page apply). */
  placements: Array<any>;
}

const CommissionSheetBulkExport: FC<ICommissionSheetBulkExportProps> = ({
  placements,
}) => {
  // Same gate as the detail page's button: a row only means something once
  // every split user on both sides has a commission entry, so the rest are
  // left out of the sheet rather than pasted with half-filled F/G cells.
  const buildRow = useCallback((placement: IDhSheetPlacement): IDhSheetRow => {
    const { columns, commissionsComplete } = buildCommissionSheetRow({
      placement: sheetPlacement(placement),
      placementSplitting: sheetSplitting(placement),
      commissions: placement?.commissions || [],
    });

    return {
      columns,
      include: commissionsComplete,
      skipReason: commissionsComplete ? undefined : 'commissions',
    };
  }, []);

  return (
    <DhSheetBulkExport
      buttonLabel="Commission Sheet"
      modalTitle="Commission Sheet Rows"
      placements={placements}
      buildRow={buildRow}
      emptyMessage="No direct-hire placements on this page have their commissions fully entered"
      skipNotes={{
        commissions: (count) =>
          count === 1
            ? '1 direct-hire placement left out — commissions not fully entered'
            : `${count} direct-hire placements left out — commissions not fully entered`,
      }}
    />
  );
};

export default CommissionSheetBulkExport;
